exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.h72[data-v-5247eca0]{\n  height:72px;\n  overflow:hidden;\n}\n", "", {"version":3,"sources":["E:/lib/iview/src/yxUIComponent/custom/baseInfo.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;CACjB","file":"baseInfo.vue","sourcesContent":["\n.h72[data-v-5247eca0]{\n  height:72px;\n  overflow:hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5247eca0","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/yxUIComponent/custom/baseInfo.vue
// module id = 713
// module chunks = 0